import jwtAxios from '@nxsys/services/axios';
import { endPoints } from '@nxsys/services/endpoints';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  GetAgencyEmployeeDashboardListParams,
  GetAgencyEmployeeDashboardListResponse,
  GetAgencyPaymentListParams,
  GetAgencyPaymentListResponse,
  GetAgencyTimesheetListParams,
  GetAgencyTimesheetListResponse,
  GetAssignmentDashboardListParams,
  GetAssignmentDashboardListResponse,
  GetDashboardPaymentEPSListParams,
  GetDashboardPaymentEPSListResponse,
  GetDashboardPaymentListParams,
  GetDashboardPaymentListResponse,
  GetEmployeeAssignmentListParams,
  GetEmployeeAssignmentListResponse,
  GetEmployeeAwaitingPaymentListParams,
  GetEmployeeAwaitingPaymentListResponse,
  GetEmployeeDashboardListParams,
  GetEmployeeDashboardListResponse,
  GetEmployeeDocumentNearingExpiryListParams,
  GetEmployeeDocumentNearingExpiryListResponse,
  GetEmployeeTimesheetListParams,
  GetEmployeeTimesheetListResponse,
  GetExpenseListParams,
  GetExpenseListResponse,
  GetInvoicingListParams,
  GetInvoicingListResponse,
  GetLeaverFPSListParams,
  GetLeaverFPSListResponse,
  GetOnHoldListParams,
  GetOnHoldListResponse,
  GetPaymentFileListParams,
  GetPaymentFileListResponse,
  GetDashboardRequiredAlertsResponse,
} from '../types';

export const getDashboardPaymentList = createAsyncThunk<
  GetDashboardPaymentListResponse,
  GetDashboardPaymentListParams
>(
  'dashboard/getDashboardPaymentList',
  async (params: GetDashboardPaymentListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.dashboard.payment, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getDashboardPaymentEPSList = createAsyncThunk<
  GetDashboardPaymentEPSListResponse,
  GetDashboardPaymentEPSListParams
>(
  'dashboard/getDashboardPaymentEPSList',
  async (params: GetDashboardPaymentEPSListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.dashboard.paymentEPS, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getLeaverFPSList = createAsyncThunk<
  GetLeaverFPSListResponse,
  GetLeaverFPSListParams
>(
  'dashboard/getLeaverFPSList',
  async (params: GetLeaverFPSListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.rti.leaverFPS, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getExpenseList = createAsyncThunk<
  GetExpenseListResponse,
  GetExpenseListParams
>(
  'dashboard/getExpenseList',
  async (params: GetExpenseListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.expenses.main, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getInvoicingList = createAsyncThunk<
  GetInvoicingListResponse,
  GetInvoicingListParams
>(
  'dashboard/getInvoicingList',
  async (params: GetInvoicingListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.dashboard.invoices, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getOnHoldList = createAsyncThunk<
  GetOnHoldListResponse,
  GetOnHoldListParams
>(
  'dashboard/getOnHoldList',
  async (params: GetOnHoldListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.dashboard.onHoldTimeSheet, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getPaymentFileList = createAsyncThunk<
  GetPaymentFileListResponse,
  GetPaymentFileListParams
>(
  'dashboard/getPaymentFileList',
  async (params: GetPaymentFileListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.dashboard.payment, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getEmployeeDashboardList = createAsyncThunk<
  GetEmployeeDashboardListResponse,
  GetEmployeeDashboardListParams
>(
  'dashboard/getEmployeeDashboardList',
  async (params: GetEmployeeDashboardListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.dashboard.subcontractor, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getAssignmentDashboardList = createAsyncThunk<
  GetAssignmentDashboardListResponse,
  GetAssignmentDashboardListParams
>(
  'dashboard/getAssignmentDashboardList',
  async (params: GetAssignmentDashboardListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.dashboard.assignment, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getPlacementDashboardList = createAsyncThunk<
  GetAssignmentDashboardListResponse,
  GetAssignmentDashboardListParams
>(
  'dashboard/getPlacementDashboardList',
  async (params: GetAssignmentDashboardListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.assignments, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getAgencyTimesheetList = createAsyncThunk<
  GetAgencyTimesheetListResponse,
  GetAgencyTimesheetListParams
>(
  'dashboard/getAgencyTimesheetList',
  async (params: GetAgencyTimesheetListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(
        `${endPoints.dashboard.agencyPortal.timesheets}/${params.agencyIds[0]}`,
        {
          params,
        },
      );
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getAgencyEmployeeDashboardList = createAsyncThunk<
  GetAgencyEmployeeDashboardListResponse,
  GetAgencyEmployeeDashboardListParams
>(
  'dashboard/getAgencyEmployeeDashboardList',
  async (params: GetAgencyEmployeeDashboardListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(
        endPoints.dashboard.agencyPortal.subcontractor,
        {
          params,
        },
      );
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getAgencyPaymentList = createAsyncThunk<
  GetAgencyPaymentListResponse,
  GetAgencyPaymentListParams
>(
  'dashboard/getAgencyPaymentList',
  async (params: GetAgencyPaymentListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(
        endPoints.dashboard.agencyPortal.payment,
        {
          params,
        },
      );
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getEmployeeAwaitingPaymentList = createAsyncThunk<
  GetEmployeeAwaitingPaymentListResponse,
  GetEmployeeAwaitingPaymentListParams
>(
  'dashboard/getEmployeeAwaitingPaymentList',
  async (params: GetEmployeeAwaitingPaymentListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(
        endPoints.dashboard.subcontractorPortal.awaitingPayment,
        {
          params,
        },
      );
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getEmployeeDocumentNearingExpiryList = createAsyncThunk<
  GetEmployeeDocumentNearingExpiryListResponse,
  GetEmployeeDocumentNearingExpiryListParams
>(
  'dashboard/getEmployeeDocumentNearingExpiryList',
  async (
    params: GetEmployeeDocumentNearingExpiryListParams,
    { rejectWithValue },
  ) => {
    try {
      const response = await jwtAxios.get(
        endPoints.dashboard.subcontractorPortal.document(
          params.subcontractorId || '',
        ),
        {
          params,
        },
      );
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getEmployeeTimesheetList = createAsyncThunk<
  GetEmployeeTimesheetListResponse,
  GetEmployeeTimesheetListParams
>(
  'dashboard/getEmployeeTimesheetList',
  async (params: GetEmployeeTimesheetListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(
        endPoints.dashboard.subcontractorPortal.timeSheet,
        {
          params,
        },
      );
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getEmployeeAssignmentList = createAsyncThunk<
  GetEmployeeAssignmentListResponse,
  GetEmployeeAssignmentListParams
>(
  'dashboard/getEmployeeAssignmentList',
  async (params: GetEmployeeAssignmentListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(
        endPoints.dashboard.subcontractorPortal.assignment,
        {
          params,
        },
      );
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getDashboardRequiredAlerts = createAsyncThunk<
  GetDashboardRequiredAlertsResponse,
  { paymentModels?: string[] } | void
>(
  'dashboard/getDashboardRequiredAlerts',
  async (params, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(
        endPoints.dashboard.requiredAlerts,
        { params: params || {} },
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const dashboardActs = {
  getDashboardPaymentList,
  getDashboardPaymentEPSList,
  getLeaverFPSList,
  getExpenseList,
  getInvoicingList,
  getOnHoldList,
  getPaymentFileList,
  getEmployeeDashboardList,
  getAssignmentDashboardList,
  getPlacementDashboardList,
  getAgencyTimesheetList,
  getAgencyEmployeeDashboardList,
  getAgencyPaymentList,
  getEmployeeAwaitingPaymentList,
  getEmployeeDocumentNearingExpiryList,
  getEmployeeTimesheetList,
  getEmployeeAssignmentList,
  getDashboardRequiredAlerts,
};
